'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { socketInstance } from './instance';
import { SOCKET_EVENT } from './types';
import type { ISocketService, MessageData } from './types';
type Unsubscribe = () => void;
export function useSocket(t0) {
  const $ = _c(20);
  const service = t0 === undefined ? socketInstance : t0;
  let t1;
  if ($[0] !== service) {
    t1 = () => service.isConnected();
    $[0] = service;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [isConnected, setIsConnected] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Set();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const cleanupSetRef = useRef(t2);
  let t3;
  let t4;
  if ($[3] !== service) {
    t3 = () => {
      const handleConnect = () => setIsConnected(true);
      const handleDisconnect = () => setIsConnected(false);
      service.on(SOCKET_EVENT.CONNECT, handleConnect);
      service.on(SOCKET_EVENT.DISCONNECT, handleDisconnect);
      setIsConnected(service.isConnected());
      const cleanupSet = cleanupSetRef.current;
      return () => {
        service.off(SOCKET_EVENT.CONNECT, handleConnect);
        service.off(SOCKET_EVENT.DISCONNECT, handleDisconnect);
        cleanupSet.forEach(_temp);
        cleanupSet.clear();
      };
    };
    t4 = [service];
    $[3] = service;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== service) {
    t5 = () => service.connectSocket();
    $[6] = service;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const connect = t5;
  let t6;
  if ($[8] !== service) {
    t6 = () => service.disconnectSocket();
    $[8] = service;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const disconnect = t6;
  let t7;
  if ($[10] !== service) {
    t7 = (event, data, callback) => {
      const handleSendOk = () => {
        callback?.();
      };
      service.send(event, data, handleSendOk);
    };
    $[10] = service;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const send = t7;
  let t8;
  if ($[12] !== service) {
    t8 = (event_0, callback_0) => {
      const listener = callback_0 as (data: unknown) => void;
      service.on(event_0, listener);
      const off = () => {
        service.off(event_0, listener);
        cleanupSetRef.current.delete(off);
      };
      cleanupSetRef.current.add(off);
      return off;
    };
    $[12] = service;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const on = t8;
  let t9;
  if ($[14] !== connect || $[15] !== disconnect || $[16] !== isConnected || $[17] !== on || $[18] !== send) {
    t9 = {
      isConnected,
      connect,
      disconnect,
      send,
      on
    };
    $[14] = connect;
    $[15] = disconnect;
    $[16] = isConnected;
    $[17] = on;
    $[18] = send;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp(cleanup) {
  return cleanup();
}